module.exports = __webpack_public_path__ + "img/Frame 5120.54e9fbef.jpg";